import { render, staticRenderFns } from "./ExplorationFacebookPopup.vue?vue&type=template&id=af7473ae&scoped=true&"
import script from "./ExplorationFacebookPopup.vue?vue&type=script&lang=js&"
export * from "./ExplorationFacebookPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExplorationFacebookPopup.vue?vue&type=style&index=0&id=af7473ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7473ae",
  null
  
)

export default component.exports